module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-60x60-precomposed-5a4c2982.png";